const STORAGE_KEY = 'push-prompt-dismissed';

export type PushPromptState = 'not-asked' | 'granted' | 'denied' | 'dismissed';

export const PushPromptService = {
    getState(): PushPromptState {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            return stored as PushPromptState;
        }

        if (!('Notification' in window)) {
            return 'denied';
        }

        switch (Notification.permission) {
            case 'granted':
                return 'granted';
            case 'denied':
                return 'denied';
            default:
                return 'not-asked';
        }
    },

    setState(state: PushPromptState): void {
        localStorage.setItem(STORAGE_KEY, state);
    },

    dismiss(): void {
        this.setState('dismissed');
    },
    
    shouldShow(): boolean {
        const state = this.getState();
        return state === 'not-asked';
    }
}